/*
 * megamenu-popout.js
 *
 * Behaviour for the 3-column popout mega menu (megamenu_style_6):
 *  1. Positions the popout immediately below the entire header
 *     group (announcement bar + nav) by summing the bottom of the
 *     LAST visible header-group section. Writes the result to the
 *     --mm6-top CSS variable (px).
 *  2. Hover-swap behaviour on Column-1 buttons.
 *
 * Visibility (open/close on hover) is handled in CSS.
 */
(function () {
  function getHeaderBottom() {
    // Sum visible bottoms from candidate header elements. Section
    // wrappers around a transparent header have height 0 (their
    // contents are position: absolute), so we walk into the inner
    // header-nav element directly instead of relying on the wrapper
    // rect.
    var candidates = [];
    var add = function (selector) {
      document.querySelectorAll(selector).forEach(function (el) { candidates.push(el); });
    };
    add('.section-header-navigation .header-navigation-wrapper');
    add('.section-header-navigation .header-nav-hamburger');
    add('.section-header-navigation');
    add('#shopify-section-announcement-bar .announcement-bar');
    add('.shopify-section-header-sticky');
    add('header');

    var max = 0;
    for (var i = 0; i < candidates.length; i++) {
      var rect = candidates[i].getBoundingClientRect();
      if (rect.bottom > max) max = rect.bottom;
    }
    if (max > 0) return max;
    return 110;
  }

  function updateTop() {
    var bottom = Math.max(0, getHeaderBottom());
    document.documentElement.style.setProperty('--mm6-top', bottom + 'px');
  }

  function bind(root) {
    var cats = root.querySelectorAll('.megamenu-popout__category');
    var panes = root.querySelectorAll('.megamenu-popout__sublinks-pane');
    var imgs = root.querySelectorAll('.megamenu-popout__image');

    if (!cats.length) return;

    function activate(idx) {
      cats.forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.categoryIndex === idx);
      });
      panes.forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.categoryIndex === idx);
      });
      imgs.forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.categoryIndex === idx);
      });
    }

    cats.forEach(function (cat) {
      cat.addEventListener('mouseenter', function () {
        activate(this.dataset.categoryIndex);
      });
      cat.addEventListener('focus', function () {
        activate(this.dataset.categoryIndex);
      });
    });

    var parentLi = root.closest('.menu-lv-item');
    if (parentLi) {
      parentLi.addEventListener('mouseenter', updateTop);
    }
  }

  function init() {
    updateTop();
    document.querySelectorAll('.megamenu_style_6').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
   * Force-close the popout on scroll.
   *
   * The popout is position:fixed and CSS :hover doesn't update on
   * scroll (the cursor doesn't move relative to the viewport, so
   * the browser keeps :hover true on whatever was last under it).
   * Result: scrolling the page leaves the popout sitting open even
   * after the cursor has effectively left the cream column.
   *
   * Fix: when the user scrolls, tag <html> with .mm6-scroll-close
   * which forcibly hides every megamenu_style_6 popout via CSS
   * (component-megamenu.css). The class is removed on the next
   * mousemove so a real hover re-opens the popout normally.
   */
  var scrollCloseTimer = null;
  function armScrollClose() {
    document.documentElement.classList.add('mm6-scroll-close');
  }
  function releaseScrollClose() {
    document.documentElement.classList.remove('mm6-scroll-close');
  }

  window.addEventListener('scroll', function () {
    updateTop();
    armScrollClose();
    // Auto-release after a short pause in case the user never moves
    // the cursor — otherwise the next genuine hover would be blocked.
    if (scrollCloseTimer) clearTimeout(scrollCloseTimer);
    scrollCloseTimer = setTimeout(releaseScrollClose, 400);
  }, { passive: true });

  window.addEventListener('mousemove', releaseScrollClose, { passive: true });
  window.addEventListener('resize', updateTop);
  window.addEventListener('load', updateTop);

  document.addEventListener('shopify:section:load', function (e) {
    updateTop();
    e.target.querySelectorAll('.megamenu_style_6').forEach(bind);
  });
})();
